export type MutationErrorExtensionsCCGraphql<TExtension> = {
	__typename: 'MutationError';
	extensions: TExtension[];
};
export type MutationErrorExtensionsAgg<TExtension> = {
	__typename: 'MutationError';
	extensions: TExtension;
};

export function mutationErrorExtensionsAggCompat<
	TExtension,
	TError extends MutationErrorExtensionsAgg<TExtension>,
>(mutationErrors: readonly TError[]): (TError & MutationErrorExtensionsCCGraphql<TExtension>)[] {
	return mutationErrors.map((e) => ({
		...e,
		// The Array check is a workaround for the fact that the GraphQL schema
		// can be different during __runtime__ between AGG and cc-graphql, which
		// is controlled by the `ATL-AGG-Confluence-MutationError-Compat: false` header.
		extensions: Array.isArray(e.extensions) ? e.extensions : [e.extensions],
	}));
}
